import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { SublistRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: SublistRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function SublistRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "sublist",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("SublistRegionTypeCard.title")}
      description={t("SublistRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
